import request from '@/utils/request'


export function login(data) {  
    return request({
      url: '/api/access/login',
      method: 'post',
      data
    })
  }

  // 退出登录
export function loginOut() {
  return request({
    url: '/api/access/logout',
    method: 'get'
  })
}
//心跳
export function heart() {
  return request({
    url: '/api/access/heart',
    method: 'get'
  })
}

//用户列表
export function getUserList(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/user/list',
    method: 'post',
    data
  })
}
//增加用户
export function getUserAdd(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/user/add',
    method: 'post',
    data
  })
}
//编辑用户信息
export function getUserPasswordEdit(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/user/editpwd',
    method: 'post',
    data
  })
}

//禁用用户
export function getUserDisable(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/user/disable',
    method: 'post',
    data
  })
}


export function getUserDelete(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/user/delete',
    method: 'post',
    data
  })
}

//用户角色
export function getRole(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/user/role',
    method: 'post',
    data
  })
}



export function hanldChangeUserlang(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/user/changelang',
    method: 'post',
    data
  })
}


//操作日志
export function getOperationlog(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/user/operationlog',
    method: 'post',
    data
  })
}

export async function fetchUserOptions() {
  try {
    const formData = {
      pageNum: 1,
      pageSize: 1000,
      lang: localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
    };

    const response = await getRole(formData);
    
    // 确保返回的数据结构包含 roleOptions.list
    return {
      roleOptions: {
        list: response.data.list || [] // 使用空数组作为默认值
      }
    };
  } catch (error) {
    console.error('Error fetching user options:', error);
    throw error;
  }
}